import { render, staticRenderFns } from "./link-config.vue?vue&type=template&id=2f6c8d5c&scoped=true"
import script from "./link-config.vue?vue&type=script&lang=js"
export * from "./link-config.vue?vue&type=script&lang=js"
import style0 from "./link-config.vue?vue&type=style&index=0&id=2f6c8d5c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f6c8d5c",
  null
  
)

export default component.exports